﻿window.cObjetDocCptModeReglementMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Règlement"; }
    this.mGetAttributBase = function () { return "les " }
    this.mGetNewLib = function () { return "Nouveau règlement"; }
    this.mGetLib1 = function (option) {
        if (!option) option = {}
        var txt = ""
        if (typeof option.dataTemplate != 'undefined') {
            return mGetLib1(option.dataTemplate)
        } else {
            if (typeof objet.data != 'undefined') {
                var libReg = objet.bddRef.mGetArray("mode_reglement").filter(function (o) { return o.id_mode_reglement == objet.data.id_mode_reglement })[0].nom
                if (objet.data.id_mode_reglement == 12) {
                    if (objet.data.id_centrale_reservation) {
                        var central = objet.bddRef.mGetArray("centrale_reservation").filter(function (o) { return o.id_centrale_reservation == objet.data.id_centrale_reservation })[0]
                        if (central) {
                            libReg += " (" + central.nom + ")"
                        }
                    }
                }
                if (objet.data.id_reservation_arrhes) libReg = "[Arrhes] " + libReg
                if (objet.data.id_mode_reglement == 9 || objet.data.id_mode_reglement == 10) {
                    if (objet.data.mt < 0) { libReg += " [création]" }
                    else { libReg += " [utilisation]" }
                }
                txt = libReg
            } else {
                txt = "Règlement"
            }
            if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
            else { return txt }
        }


        function mGetLib1(dataTemplate) {
            var libReg = dataTemplate.nom_mode_reglement
            if (dataTemplate.id_mode_reglement == 12) {
                if (dataTemplate.id_centrale_reservation && dataTemplate.nom_centrale && dataTemplate.nom_centrale.length > 0) {
                    libReg += " (" + dataTemplate.nom_centrale + ")"
                }
            }
            if (dataTemplate.id_reservation_arrhes) libReg = "[Arrhes] " + libReg
            if (dataTemplate.id_mode_reglement == 9 || dataTemplate.id_mode_reglement == 10) {
                if (dataTemplate.mt < 0) { libReg += " [création]" }
                else { libReg += " [utilisation]" }
            }
            return libReg
        }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-piggy-bank'></i>");
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
    }

    //this.contentTemplatePopup = function (contentElement, option) {
    //    contentElement.empty();
    //}

    this.mGetItemTemplateHeight = function (type) {
        return ((type == "Détails") ? 73 : 53)
    }
    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {

        var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        if (dataTemplate.annule_origine_id_doc_cpt_mode_reglement || dataTemplate.annule_destination_id_doc_cpt_mode_reglement) {
            contentElement.closest(".divtemplate").addClass("texture_avoir_bon_cadeau_disable")
            contentElement.closest(".divtemplate").css("opacity", "0.5")
        } else {
            contentElement.closest(".divtemplate").removeClass("texture_avoir_bon_cadeau_disable")
            contentElement.closest(".divtemplate").css("opacity", "1")
        }

        //modereglement
        var $Td = $("<td style='width:30%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-size:100%'/>").appendTo($Tr)
        var libReg = this.mGetLib1({ dataTemplate: dataTemplate })
        $Td.text(libReg)

        //montant
        var $Td = $("<td style='width:20%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-size:120%'/>").appendTo($Tr)
        $Td.html(parseFloat(dataTemplate.mt).formatDisplay() + "€")
        //client
        var libCli = ""
        var $Td = $("<td style='width:50%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-size:100%'/>").appendTo($Tr)
        if (dataTemplate.doc_cpt_lib_client && dataTemplate.doc_cpt_lib_client.length > 0) {
            libCli = dataTemplate.doc_cpt_lib_client
        } else if (dataTemplate.resa_lib_client && dataTemplate.resa_lib_client.length > 0) {
            libCli = dataTemplate.resa_lib_client
        } else { libCli = "(Aucun client)" }
        $Td.text(libCli)
        $Td.attr("title", libCli)




        var $Tr = $("<tr/>").appendTo($Table)
        //client
        var $Td = $("<td style='width:30%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-size:100%'/>").appendTo($Tr)
        var libDoc = ""
        if (dataTemplate.id_doc_cpt) {
            switch (parseInt(dataTemplate.id_type_com)) {
                case 1: libDoc = "Devis"; break;
                case 2: libDoc = "Commande"; break;
                case 3: libDoc = "Facture"; break;
            }
            if (parseInt(dataTemplate.id_statut_com) == 1) {
                libDoc += " #" + dataTemplate.id_doc_cpt
                libDoc += " <span style='color:red'>brouillon</span>"
                libDoc += " " + dataTemplate.dmo_doc_cpt.toDDMMAAAA()
            } else {
                libDoc += " " + dataTemplate.doc_cpt_entete + dataTemplate.id_document
                libDoc += " <span style='color:green'>validé</span>"
                libDoc += " " + dataTemplate.date_document.toDDMMAAAA()
            }
            $Td.html("<a href='javascript:void(0);'>" + libDoc + "</a>")
            $Td.on("click", function (e) {
                e.stopPropagation()
                Me.objet.bddRef.getObjet("doc_cpt", dataTemplate.id_doc_cpt).mShowPopup()
            })
        } else if (dataTemplate.id_reservation_arrhes) {
            libDoc = "Réservation"
            if (dataTemplate.resa_date_debut) {
                libDoc += " du " + dataTemplate.resa_date_debut.toDDMMAAAA() + " au " + dataTemplate.resa_date_fin.toDDMMAAAA()
            }
            $Td.html("<a href='javascript:void(0);'>" + libDoc + "</a>")
            $Td.on("click", function (e) {
                e.stopPropagation()
                Me.objet.bddRef.getObjet("reservation", dataTemplate.id_reservation).mShowPopup()
            })
        } else {
            libDoc = "(Aucun document)"
            $Td.html(libDoc)
        }


        var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-size:100%' colspan='2'/>").appendTo($Tr)
        $Td.text(dataTemplate.commentaire_contexte)
        $Td.attr("title", dataTemplate.commentaire_contexte)

    }

    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        $("<span style='' title='Règlement le " + dataPlus.date_reglement.toFrenchDateTime() + "'><i class='fas fa-hand-holding-dollar dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.date_reglement.toDateIlya(true) + "</span>").appendTo(contentElement)
    }

    this.mShowPopup = function (optionPopup) {
        objet.bddRef.getObjet("doc_cpt", objet.data.id_doc_cpt).mShowPopup(optionPopup)
    }

    ////mt
    ////idModeReg
    ////idCentraleReservation
    ////idAvoirBonCadeau
    ////mtCreationAvoir
    ////idTable
    ////id
    ////dateReglement
    this.mCreateDocCptModeReg = function (Mt, idModeReg, dateReg, idCentraleReservation, idAvoirBonCadeau, mtCreationAvoir, idResaArrhes, idDocCpt, funcOk) {
        var opt = {
            command: "createdoccptmodereglement",
            mt: Mt,
            id_mode_reglement: idModeReg,
            id_avoir_bon_cadeau: idAvoirBonCadeau,
            mt_creation_avoir: mtCreationAvoir,
            date_reglement: dateReg,
            id_doc_cpt: idDocCpt
        }
        if (idCentraleReservation) opt.id_centrale_reservation = idCentraleReservation
        if (idResaArrhes) opt.id_reservation_arrhes = idResaArrhes
        if (idDocCpt) opt.id_doc_cpt = idDocCpt
        //switch (parseInt(option.idTable)) {
        //    case parseInt(option.bddCtrl.table.mGetItemFromNom("reservation_arrhes").id_table):
        //        opt.id_reservation_arrhes = option.id
        //        break;
        //    case parseInt(option.bddCtrl.table.mGetItemFromNom("doc_cpt").id_table):
        //        opt.id_doc_cpt = option.id
        //        break;
        //}
        objet.bddRef.mAjaxCall(opt, function (data) {
            funcOk()
        })
    }

}